export const environment = {
  production: false,
  apiUrl: 'https://dev.prismab.com/api',
  organizationName: 'org.prismab.com',
  arcgis: {
    apiKey: 'AAPTamYLfhBr6hH9VzinckPtu-w..PD0BLRqFdn7MShCmyn0EEobfr-y58KwlEvasw6ay-rd_PrqGVdrCag9_37PhExWy3CycS2ghkyug238SuxpDVOVnYCH-2r4_HZtgyYRcq4fRC_ZeLO_ApWHlk_R5ANGpLyhyHjHKHanKGyIJNHOrhynMXBUgXBEm2C00FaEFjtORDLoV92zJr3SMe_aQLI9yML_ek0tv0NOSBcYv2O7qbWGDuwSRCO0PgNhKdjOWx1IAtbftI-ZN2g..AT1_DLVCM0UP',
  },
  // apiUrl: '//app.prismab.com/api'
  // apiUrl: 'http://localhost:3005'
};
